<template>
  <div class="subscribe-page login-entry-page">
    <main>
      <section class="subscribe-hero">
        <img class="subscribe-prize" src="../../static/images/subscribe/prize_txt.png" alt="" />
        <header class="subscribe-header">
          <img src="../../static/images/logo1.png" alt="WowBox" />
        </header>
        <div class="subscribe-scroll">
          <div class="scroll-wrapper">
            <div class="scroll-item" v-for="(item, index) in scrollLightData" :key="index">{{ item }}</div>
          </div>
        </div>
      </section>

      <div class="subscribe-content">
        <div class="subscribe-phone">
          <img class="subscribe-prefix" src="../../static/images/subscribe/09.png" alt="09" />
          <input
            v-model="mobile"
            class="subscribe-number"
            :placeholder="$t('landFont1')"
            :aria-label="$t('landFont1')"
            type="number"
          />
        </div>

        <div class="subscribe-plans">
          <button class="subscribe-plan plan-daily login-submit" type="button" @click="userStatus()">
            <span class="plan-daily-copy">{{ $t('Login') }}<img class="plan-arrow" src="../../static/images/subscribe/arrow.png" alt="" /></span>
          </button>
        </div>

        <nav class="subscribe-links">
          <button type="button" @click="getChange('termsAndCondition2')">{{ $t('TC') }}</button>
          <button type="button" @click="getChange('faq2')">{{ $t('FAQ') }}</button>
        </nav>
      </div>
    </main>

    <Dialog ref="resubDialog" modalClass="resub-dialog" type="alert" title="" width="90" :modalFoot="false" :iscloseMask="true">
      <div class="resub-alert-modal" slot="mdBox" role="alertdialog" aria-modal="true" :aria-label="$t('re_sub_tip')">
        <h2 class="resub-title">{{ $t('re_sub_tip') }}</h2>
        <div class="resub-actions">
          <button class="resub-action resub-subscribe" type="button" @click="goSubscribe">{{ $t('subscribe') }}</button>
          <button class="resub-action resub-login" type="button" @click="goOtpLogin">{{ $t('Login') }}</button>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import Header from '../components/headerNo'
import Dialog from '../components/dialog'
export default {
  components: {
    Dialog,
    Header
  },
  data() {
    return {
      isShow: false,
      type: '',
      isEN: 'bur',
      mobile: '',
      showWeekly: false,
      showDaily: false,
      showMonth: false,
      //走马灯
      scrollLightData: {}
    }
  },

  created() {
    let that = this
    if (localStorage.getItem('lang')) this.isEN = localStorage.getItem('lang')
    this.getLandConfig();
    this.scrollLight();
    if (this.$route.query.mobile) {
      that.mobile = that.dealPhone_2(that.$route.query.mobile)
    }
    //渠道是atomber 且 有号码的
    let channelId = this.$route.query.channelId;
    if (channelId == 'atomber' && that.mobile) {
      //查询订阅状态 直接到daily cg
      this.type = "daily";
      that.userStatus();
    }
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    userStatus() {
      let that = this
      if (that.mobile == '') {
        that.$utils.alertText(that.$t('enderNumber'), 80)
        return;
      }
      let mobile = '09' + that.mobile
      mobile = that.dealPhone(mobile)
      const deviceId = this.getDeviceId();
      let data = {
        mobile: mobile,
        device_id: deviceId
      }
      that.$parent.loadModal(true);
      that.$api.post('/api/user/user_status', data, r => {
        that.$parent.loadModal(false);
        that.$parent.returnCode(r, function () {
          if (r.code == 0) {
            that.$utils.alertText(r.msg, 80);
          } else {
            if (r.data.status == 1 || r.data.status == -2) {
              that.goOtpLogin();
              return;
            }
            if (r.data.status ==  3 && r.data.valid == 'Y'){
              that.$refs.resubDialog.showMaskFun();
              return;
            }
            that.goSubscribe();
          }
        })
      })
    },
    goOtpLogin() {
      this.$router.push({
        path: '/otpLogin',
        query: this.getPageQuery()
      })
    },
    goSubscribe() {
      this.$router.push({
        path: '/subscribe',
        query: this.getPageQuery()
      })
    },
    getPageQuery() {
      let query = Object.assign({}, this.$route.query)
      query.mobile = this.mobile
      query.subappid = this.type
      return query
    },
    getLandConfig() {
      let that = this
      let url = '/api/land/config'
      that.$api.get(url, {}, r => {
      })
    },
    dealPhone(phone) {
      phone = phone.replace(/\s+/g, ''); // 移除所有空格
      if (phone.startsWith('0909') && phone.length === 13) {
        phone = phone.substring(3);
      }
      if (phone.startsWith('09') && phone.length === 11) {
        phone = phone.substring(1);
      }
      if (phone.startsWith('099') && phone.length === 12) {
        phone = phone.substring(2);
      }
      return phone;
    },
    dealPhone_2(phone) {
      phone = phone.replace(/\s+/g, ''); // 移除所有空格
      if (phone.startsWith('97') && phone.length === 10) {
        phone = phone.substring(1);
      }
      return phone;
    },
    getChange(type) {
      let that = this;
      that.$router.push({path: '/' + type})
    },
    scrollLight() {
      let that = this
      let data = {}
      that.$api.post('/api/index/scroll_light', data, r => {
        that.$parent.returnCode(r, function () {
          that.scrollLightData = r.data
        })
      })
    },
    getDeviceId() {
      let id = localStorage.getItem('device_id');
      if (!id) {
        id = 'dev-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
        localStorage.setItem('device_id', id);
      }
      return id;
    },
  }
}
</script>

<style scoped>
.subscribe-page {
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
  background: #080e36 url(../../static/images/index/main_bg.jpg) no-repeat center top;
  background-size: 100% 100%;
  color: #fff;
  font-family: Atom-sans;
}

.subscribe-hero {
  position: relative;
  width: 100%;
  aspect-ratio: 1125 / 1729;
}

.subscribe-prize {
  position: absolute;
  top: -0.55rem;
  left: 0;
  display: block;
  width: 100%;
  height: 100%;
}

.subscribe-header {
  position: absolute;
  z-index: 2;
  top: 0.6rem;
  left: 50%;
  width: 1.6rem;
  transform: translateX(-50%);
}

.subscribe-header img {
  display: block;
  width: 100%;
}

.subscribe-scroll {
  position: absolute;
  z-index: 2;
  top: 2.28rem;
  left: 6%;
  width: 88%;
  height: 0.68rem;
  overflow: hidden;
  border-top: 0.01rem solid rgba(69, 128, 255, 0.4);
  border-bottom: 0.01rem solid rgba(69, 128, 255, 0.4);
  background: linear-gradient(90deg, transparent, #005bdf 48%, transparent);
  font-size: 0.24rem;
  line-height: 0.34rem;
  text-align: center;
}

.scroll-wrapper {
  position: absolute;
  width: 100%;
  animation: scrollUp 60s linear infinite;
}

.scroll-item {
  height: 0.34rem;
  overflow: hidden;
  color: #fff;
  line-height: 0.34rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@keyframes scrollUp {
  from { transform: translateY(0); }
  to { transform: translateY(-100%); }
}

.subscribe-content {
  position: relative;
  z-index: 1;
  margin-top: -0.97rem;
  padding-bottom: 0.48rem;
}

.subscribe-phone {
  width: 4.97rem;
  height: 0.93rem;
  display: flex;
  align-items: center;
  margin: 0 auto;
  background: url(../../static/images/subscribe/phone_input_bg.png) no-repeat center;
  background-size: 100% 100%;
}

.subscribe-prefix {
  display: block;
  width: 1.14rem;
  height: 0.71rem;
  margin-left: 0.09rem;
  object-fit: contain;
}

.subscribe-number {
  flex: 1;
  min-width: 0;
  height: 100%;
  padding: 0 0.32rem;
  border: 0;
  background: transparent;
  color: #fff;
  font-family: Atom-sans-bold;
  font-size: 0.38rem;
  letter-spacing: 0;
}


.subscribe-number::placeholder {
  color: #757da9;
  -webkit-text-fill-color: #757da9;
  font-size: 0.28rem;
  opacity: 1;
}

.subscribe-plans {
  margin-top: 0.5rem;
}

.subscribe-plan {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  color: #fff;
  font-family: Atom-sans-bold;
  cursor: pointer;
}

.plan-daily {
  width: 3.85rem;
  height: 1.35rem;
  margin: 0 auto;
  background: url(../../static/images/subscribe/daily_btn_bg.png) no-repeat center;
  background-size: 100% 100%;
  font-size: 0.38rem;
}

.plan-daily-copy {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}

.plan-arrow {
  width: 0.19rem;
  height: 0.31rem;
  margin-left: 0.08rem;
  object-fit: contain;
}

.subscribe-links {
  width: 5rem;
  display: flex;
  justify-content: space-between;
  gap: 0.3rem;
  margin: 1.89rem auto 0;
}

.subscribe-links button {
  min-width: 1.4rem;
  padding: 0;
  border: 0;
  background: none;
  color: #b7b4ea;
  font-family: Atom-sans;
  font-size: 0.27rem;
  text-align: center;
  text-decoration: underline;
  text-underline-offset: 0.05rem;
}

.subscribe-number::-webkit-inner-spin-button,
.subscribe-number::-webkit-outer-spin-button {
  margin: 0;
  -webkit-appearance: none;
}

.resub-alert-modal {
  width: 100%;
  padding: 0.52rem 0.4rem 0.48rem;
  overflow: hidden;
  border: 0.03rem solid #61bbff;
  border-radius: 0.32rem;
  background: radial-gradient(circle at 50% 0, #394cac, transparent 58%), linear-gradient(160deg, #171b58, #080d36 80%);
  box-shadow: 0 0.18rem 0.65rem rgba(0, 5, 38, 0.55), inset 0 0 0.35rem rgba(93, 119, 255, 0.35);
  color: #fff;
  text-align: center;
}

.resub-title {
  margin: 0 0 0.38rem;
  color: #fff;
  font-family: Atom-sans-bold;
  font-size: 0.38rem;
  font-weight: normal;
  line-height: 1.38;
  text-transform: uppercase;
  overflow-wrap: anywhere;
}

.resub-actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.2rem;
}

.resub-action {
  width: 70%;
  min-height: 0.84rem;
  padding: 0.14rem 0.2rem;
  border: 0.025rem solid #fff;
  border-radius: 0.48rem;
  color: #fff;
  font-family: Atom-sans-bold;
  font-size: 0.32rem;
  line-height: 1.25;
  text-transform: uppercase;
  cursor: pointer;
}

.resub-subscribe {
  background: linear-gradient(#ff64c5, #df0675 55%, #a90c78);
  box-shadow: inset 0 0.08rem 0.12rem rgba(255, 255, 255, 0.45), 0 0.08rem 0.2rem rgba(238, 36, 151, 0.38);
}

.resub-login {
  background: linear-gradient(#3478ff, #0759d4 55%, #2ad9ef);
  box-shadow: inset 0 0.08rem 0.12rem rgba(255, 255, 255, 0.4), 0 0.08rem 0.2rem rgba(34, 173, 255, 0.3);
}
</style>

<style>
.modal.resub-dialog .modal-bg {
  background: rgba(3, 6, 31, 0.72);
}

.modal.resub-dialog .modal-content {
  width: 90% !important;
  max-width: 440px;
  max-height: calc(100vh - 1rem);
  min-height: 0;
  margin-left: 0 !important;
  padding: 0;
  overflow-y: auto;
  transform: translate(-50%, -50%);
}

.modal.resub-dialog .modal-warp {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/page/login.vue